export default __webpack_public_path__ + "static/media/Roundinggif.133400b3.gif";